import React from 'react';
import { Dialogs, Dialog } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import SearchEditor from "../editor/SearchEditor.js";
import UserSettingsModelEditor from "../../../../views/userSettings/UserSettingsModelEditor.js";
import S from './MobileSearchSettings.css';
import GroupedTextFilterModel from "../filter/GroupedTextFilterModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.SearchSettings');
export default {
  id: 'molten.screens.group.search.MobileSearchSettings',
  matches: {
    use: 'actionBar',
    client: 'molten.groupMobile.SearchBar'
  },
  handles: context => {
    return context?.clientProps?.searchModel?.TYPE === GroupedTextFilterModel.TYPE;
  },
  layout: {
    sort: 'zzzz'
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('icon', 'fa fa-cog fa-fw')
    };
  },
  perform: ({
    context,
    action
  }) => {
    const {
      clientProps
    } = context;
    const {
      settingsPath,
      objectType
    } = clientProps;
    Dialogs.show({
      component: props => {
        const {
          show,
          onClose
        } = props;
        return /*#__PURE__*/_jsx(Dialog, {
          variant: "mobileSearchSettings|mobileDialog",
          animation: "appear",
          position: "full",
          show: show,
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onClose: onClose,
          children: /*#__PURE__*/_jsx(UserSettingsModelEditor, {
            className: S.test,
            ...props
          })
        });
      },
      props: {
        simple: false,
        editor: SearchEditor,
        settingsPath,
        versionsPath: `${objectType}.freeTextSearch`,
        title: t('title'),
        modelName: t('modelName'),
        editorProps: {
          objectType
        }
      },
      id: action.id
    });
  }
};